import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

class IconCircleSwitch extends PureComponent {
    constructor(props) {
        super(props);

        this.isControlled = this.props.checked !== undefined;
        this.state = {
            isChecked: !!this.props.checked,
        };
    }
    changeHandler = ( e ) => {
        var newState = e.target.checked;
        var value = e.target.value;
        if( !this.isControlled ) {
            this.setState( { isChecked: newState } );
        }
        this.props.onChange( e, newState, value );
    }
    render() {
        var isChecked = this.state.isChecked;
        if( this.isControlled ) {
            isChecked = !!this.props.checked;
        }

        var inlineStyle = { ...this.props.style };
        if( this.props.size ) {
            inlineStyle.width = inlineStyle.height = this.props.size + 'px';
        }

        var icon = this.props.icon || this.props.label;

        var inputProps = {
            onChange: this.changeHandler,
            value: this.props.value,
            name: this.props.name,
            checked: isChecked,
        };

        return (
            <div className={ `${ this.props.className } ${ style.iconCircleSwitch }` }
            style={ inlineStyle } >
                <label data-checked={ isChecked } data-value={ inputProps.value }>
                    <input type='checkbox' { ...inputProps } />

                    { icon &&
                        <div className={ style.icon }>{ icon }</div>
                    }
                </label>
            </div>
        );
    }
}
IconCircleSwitch.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    icon: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.object,
    ] ),
    label: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.object,
    ] ),
    style: PropTypes.object,
    size: PropTypes.number,
};
IconCircleSwitch.defaultProps = {
    className: '',
    onChange: () => {},
    onClick: () => {},
};

export default IconCircleSwitch;
